import { EmptyValidation, ReportsEnum } from "@domains/utils/commonText";
import { EmptyIcon } from "@adapters/presenters/action-interfaces/Reports/HoldingReport";
import summarize from "@domains/utils/summarize";
class TaxReportPresenter {
    constructor(useCases, actions) {
        this.useCases = useCases;
        this.actions = actions;
        this.initTaxData = {
            taxSummary: {
                tradingGain: "",
                shortTermGain: "",
                longTermGain: "",
                totalGain: "",
            },
            taxDetail: [],
        };
        this.TaxReportData = this.initTaxData;
    }
    getTaxReportData(requestData) {
        this.actions.tax.getTaxReport(this.initTaxData, "tax");
        this.actions.tax.hideError("tax");
        this.actions.tax.clear("tax");
        this.actions.tax.loader("tax");
        this.useCases.tax.execute({
            onSuccess: (taxData) => {
                var _a;
                if (((_a = taxData === null || taxData === void 0 ? void 0 : taxData.taxDetail) === null || _a === void 0 ? void 0 : _a.length) === 0) {
                    const emptyValidation = EmptyValidation[EmptyIcon.EMPTY][ReportsEnum.TAX];
                    this.actions.tax.addMsg(emptyValidation.message, true, emptyValidation.icon, "tax");
                }
                else {
                    this.actions.tax.getTaxReport(taxData, "tax");
                    this.TaxReportData = taxData;
                }
                this.actions.tax.stopLoader("tax");
            },
            onError: (error) => {
                this.actions.tax.setError({
                    error,
                    isOpen: true,
                }, "tax");
                this.actions.tax.stopLoader("tax");
            },
        }, requestData);
    }
    summarizeTaxReport(isSummarize) {
        if (isSummarize) {
            let summarized = {
                taxSummary: {
                    tradingGain: summarize(Number(this.TaxReportData.taxSummary.tradingGain)),
                    shortTermGain: summarize(Number(this.TaxReportData.taxSummary.shortTermGain)),
                    longTermGain: summarize(Number(this.TaxReportData.taxSummary.longTermGain)),
                    totalGain: summarize(Number(this.TaxReportData.taxSummary.totalGain)),
                },
                taxDetail: this.TaxReportData.taxDetail.map((taxDetail) => {
                    return Object.assign(Object.assign({}, taxDetail), { tradingGain: summarize(Number(taxDetail.tradingGain)), shortTermGain: summarize(Number(taxDetail.shortTermGain)), longTermGain: summarize(Number(taxDetail.longTermGain)), totalGain: summarize(Number(taxDetail.totalGain)), dividend: summarize(Number(taxDetail.dividend)), interest: summarize(Number(taxDetail.interest)) });
                }),
            };
            this.actions.tax.getTaxReport(summarized, "tax");
        }
        else
            this.actions.tax.getTaxReport(this.TaxReportData, "tax");
        this.actions.tax.taxSummarize(isSummarize, "tax");
    }
    clearTax(req) {
        return new Promise((resolve, reject) => {
            this.useCases.clearTax.execute({
                onSuccess: (clearTax) => {
                    resolve(clearTax);
                },
                onError: (error) => {
                    reject(error);
                },
            }, req);
        });
    }
}
export default TaxReportPresenter;
